<!-- Main Header-->
<div class="main-header side-header sticky">
    <div class="container-fluid">
        <div class="main-header-left deskIcon">
            <a class="main-header-menu-icon" href="javascript:void(0)" id="mainSidebarToggle" (click)="toggleSidebar()">
                <span></span>
            </a>
        </div>
        <div class="main-header-left mobileIcon">
            <a class="main-header-menu-icon" href="javascript:void(0)" id="mainSidebarToggleMobile"
                (click)="toggleMobileSidebar()">
                <span></span>
            </a>
        </div>
        <div class="main-header-center">
            <div class="responsive-logo">
                <a (click)="pathToDirect"><img src="../../assets/img/brand/logo-mobile.png" class="mobile-logo"
                        alt="logo"></a>
                <a (click)="pathToDirect"><img src="../../assets/img/brand/logo-light.png" class="mobile-logo-dark"
                        alt="logo"></a>
            </div>
        </div>
        <div class="main-header-right">
            <div ngbDropdown class="main-profile-menu">
                <a ngbDropdownToggle class="d-flex" href="javascript:void(0)">
                    <span class="main-img-user"><img alt="avatar"
                            [appImageSrc]="userProfile?.image" fallbackImageSrc="./assets/img/users/default_avatar.png"></span>
                </a>
                <div ngbDropdownMenu>
                    <div class="header-navheading">
                        <h6 class="main-notification-title"> Moderator </h6>
                    </div>
                    <a ngbDropdownItem [routerLink]="['/profile/view-profile']">
                        <i class="mdi mdi-account-circle"></i> My Profile
                    </a>
                    <a ngbDropdownItem (click)="SignOut()">
                        <i class="fe fe-power"></i> Sign Out
                    </a>
                </div>
            </div>
            <button class="navbar-toggler navresponsive-toggler" type="button" (click)="collapse.toggle()"
                [attr.aria-expanded]="!isCollapsed">
                <i class="fe fe-more-vertical header-icons navbar-toggler-icon"></i>
            </button>
        </div>
    </div>
</div>
<!-- End Main Header-->

<!-- Mobile-header -->
<div class="mobile-main-header">
    <div ngbDropdown class="main-profile-menu" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
        <a ngbDropdownToggle class="d-flex" href="javascript:void(0)">
            <span class="main-img-user">
                <img alt="avatar" [src]="userProfile?.profileImage ? userProfile.profileImage : './assets/img/users/default_avatar.png'">
            </span>
        </a>
        <div ngbDropdownMenu>
            <div class="header-navheading">
                <p class="main-notification-title"> Moderator </p>
            </div>
            <a ngbDropdownItem (click)="viewProfile()" style="cursor: pointer;">
                <i class="mdi mdi-account-circle"></i> My Profile
            </a>
            <a ngbDropdownItem (click)="SignOut()" style="cursor: pointer;">
                <i class="fe fe-power"></i> Sign Out
            </a>
        </div>
    </div>
</div>
<!-- End Mobile-header -->

<div class="jumps-prevent" style="padding-top: 64px;"></div>